import { render } from "./changeType.vue?vue&type=template&id=5def19d8"
import script from "./changeType.vue?vue&type=script&lang=js"
export * from "./changeType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__